<template>
	<div class="refund">
		<div class="item" v-for="(item,index) in orderList" :key="index">
			<div class="header">
				<div class="img-box" style="width: 450px;">
					<span>订单号：{{ item.order.order_no }}</span>
					<span style="margin-left: 40px;">{{ item.order.create_time }}</span>
				</div>
				<div style="width: 100px;">退款金额</div>
				<div style="width: 100px;">服务类型</div>
				<div style="width: 100px;">退款状态</div>
				<div style="width: 150px;">操作</div>
			</div>
			<div class="order-content">
				<div class="img-box border-right">
					<div class="flex" v-for="(i, pIndex) in item.products" :key="pIndex">
						<img :src="i.product_image" />
						<div class="name">{{ i.product_name }}</div>
					</div>
					
				</div>
				<div class="detail-box border-right">
					<div>￥{{ item.total_refund }}</div>
				</div>
				<div class="detail-box border-right">
					<div class="price">{{ item.service_type == 1 ? "退货" : ''  }}</div>
				</div>
				<div class="detail-box border-right">
					<div class="status">{{ item.service_status_name }}</div>
				</div>
				<div class="action-box">
					<div class="action" @click="toDetail(item.order_id)">服务详情</div>
					<!-- <div class="action-cancel">取消退款</div> -->
				</div>
			</div>
		</div>
		<Page  :current="page" :total="total" @on-change="changePage" show-total style="margin-top: 20px;"></Page>
	</div>

</template>

<script>
	
	import { getServiceList } from "@/api"
	export default {
		name: 'Refund',
		components: {
			
		},
		data() {
			return {
				page:  1,
				total: -1,
				size:5,
				orderList: []
			};
		},
		created() {
			this.getList()
		},
		methods: {
			changePage(page) {
				this.page = page
				this.getList()
			},
			toDetail(order_id) {
				this.$router.push({
					path: "orderdetail",
					query: {order_id : order_id}
				});
			},
			async getList() {
				let json = await getServiceList({page: this.page, size: this.size})
				this.orderList = json.data.list
				this.total = json.data.count
			}
		}
	}
</script>

<style lang="scss" scoped>
	.refund {
		width:  950px;
		background: #FFFFFF;
		padding: 20px;
		.item {
			
			margin-bottom: 10px;
			.header{
				height: 40px;
				background: #F5F5F5;
				line-height: 40px;
				display: flex;
				text-align: center;
			}
			.order-content {
				font-size: 15px;
				color: #0F114A;
				height: 140px;
				display: flex;
				border: 1px solid #EEEEEE;
				.img-box {
					width: 450px;
					height: 140px;
					display: flex;
					padding: 20px;
					img {
						width: 100px;
						height: 100px;
						margin-right: 20px;
					}
					.name {
						font-size: 15px;
						font-family: PingFang SC;
						font-weight: bold;
						width: 288px;
						color: #333333;
						margin-top: 29px;
					}
				}

				.detail-box {
					width: 100px;
					height: 140px;
					line-height: 140px;
					text-align: center;
					font-size: 12px;
					font-weight: 400;
				}
				.status-box {
					width: 88px;
					text-align: center;
					.status {
						margin-top: 30px;
						font-size: 14px;
						font-weight: bold;
						color: #BE0505;
					}
					.detail {
						font-size: 14px;
						font-weight: 400;
						margin-top: 10px;
					}
				}

				.action-box {
					width: 150px;
					font-size: 13px;
					text-align: center;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					.action {
						margin: 0 auto;
						width: 72px;
						height: 24px;
						line-height: 24px;
						background: #0F114A;
						border-radius: 3px;
						text-align: center;
						color: #EDD4AC;
					}
					.action-cancel {
						margin: 0 auto;
						width: 72px;
						height: 24px;
						line-height: 24px;
						background: #FFFFFF;
						border-radius: 3px;
						text-align: center;
						color: #0F114A;
						margin-top: 10px;
						border: 1px solid #0F114A;

					}
				}
			}

		}
		.border-right {
			border-right: 1px solid #EEEEEE;
		}

	}
</style>
